/* eslint-disable no-alert */
import React, { useContext, useState, useEffect } from 'react';

import AssetListContext from '../../../context/assetListContext';
import JobListContext from '../../../context/jobListContext';
import PlannedJob from "../../../interfaces/plannedJob";

import DateLabel from '../../../../components/dateLabel';
import LocationLabel from '../../../../components/locationLabel';
import PlannedStatusBubble from "../../../../components/plannedStatusBubble";
import PlannedJobDetail from '../../jobDetailPlanned';
import useTextCorrection from "../../../../hooks/useTextCorrection";

import ICONS from '../../../../assets/icons';
import COLORS from '../../../../assets/styles/config/colors';

import { ActiveArrow, BtmCtn, CardBody, CardCtn, DropdownJobDetailCtn, JobTitle, TopCtn } from './index.style';

interface CardProps {
  jobDetails: PlannedJob;
  page?: string;
}

const Card: React.FC<CardProps> = ({ jobDetails, page,clickControl }): React.ReactElement => {
  const { openJobDetails, updateOpenJobDetails, selectedPlannedJob, setAppJobDetails, clearSelectedPlannedJob } = useContext(JobListContext);
  const { selectedAsset } = useContext(AssetListContext);

  let slaStatusMap;

  if(jobDetails.Status == 'Completed') {
    slaStatusMap = 'doneOnTime';
  } else if (jobDetails.Status == 'Incomplete') {
    slaStatusMap = 'missedDeadline';
  } else if(jobDetails.Status == 'Open') {
    slaStatusMap = 'upcoming';
  }

  const [ primaryColor, setPrimaryColor ] = useState(COLORS.slaPrimary[slaStatusMap]);
  const [ secondaryColor, setSecondaryColor ] = useState(COLORS.slaSecondary[slaStatusMap]);
  const [ shadowColor, setShadowColor ] = useState(COLORS.slaShadow[slaStatusMap]);

  const { filterText, titleCase } = useTextCorrection();

  const handleClick = () => {
    if (page === 'plannedMaintenance') {
      if (openJobDetails && selectedPlannedJob.PMCallNo === jobDetails.PMCallNo) {
        updateOpenJobDetails(false);
      } else {
        updateOpenJobDetails(true);
      }
      clearSelectedPlannedJob();
      setAppJobDetails({ selectedPlannedJob: jobDetails });
    }
    if(page === 'assets') {
      clickControl();
      let jobDetailsClone = jobDetails;
      const attributes = ["CUSTREF1", "CUSTREF2", "MODEL", "VENDOR", "YEARMAN"];
      attributes.map(attribute => {
        jobDetailsClone[attribute] = selectedAsset[attribute];
      });
      setAppJobDetails({ selectedPlannedJob: jobDetailsClone});
    }
  };

  return (
    <React.Fragment>
      <CardCtn>
        <CardBody
          active={selectedPlannedJob.PMCallNo === jobDetails.PMCallNo}
          home={page === 'HOME'}
          cardBorder={primaryColor}
          cardActiveBorder={secondaryColor}
          cardShadow={shadowColor}
          onClick={(e): void => {
            e.preventDefault();
            handleClick();
          }}
        >
          <TopCtn>
            <JobTitle>{titleCase(filterText(jobDetails.RoutineProcedure))}</JobTitle>
            <PlannedStatusBubble status={jobDetails.Status} />
          </TopCtn>
          <BtmCtn>
            {jobDetails.UnitLocation == undefined? "": <LocationLabel location={jobDetails.UnitLocation} />}
            <DateLabel slaStatus={slaStatusMap} date={jobDetails.RoutineDueDate} page="planned"/>
          </BtmCtn>
          <ActiveArrow
            active={selectedPlannedJob.PMCallNo === jobDetails.PMCallNo}
            home={page === 'HOME'}
            cardBorder={primaryColor}
          >
            <ICONS.chevronRight />
          </ActiveArrow>
        </CardBody>
      </CardCtn>
      <DropdownJobDetailCtn active={selectedPlannedJob.PMCallNo === jobDetails.PMCallNo && openJobDetails}>
        {window.innerWidth<=1024 && openJobDetails && selectedPlannedJob.PMCallNo === jobDetails.PMCallNo && <PlannedJobDetail />}
      </DropdownJobDetailCtn>
    </React.Fragment>
  );
};

export default Card;
